import 'models/pagination'
import { PaginationParams, PaginationResponse } from 'models/pagination'

export const InstantCardStatus = {
  connect: 'connect',
  error: 'error',
  ready: 'ready',
  give: 'give',
} as const

// eslint-disable-next-line @typescript-eslint/no-redeclare
export type InstantCardStatus =
  (typeof InstantCardStatus)[keyof typeof InstantCardStatus]

export const InstantCardType = {
  mJunior: 'm_junior',
  gold: 'gold',
} as const
// eslint-disable-next-line @typescript-eslint/no-redeclare
export type InstantCardType =
  (typeof InstantCardType)[keyof typeof InstantCardType]

export const InstantCardVersion = {
  instant: 'instant',
  personalized: 'personalized',
} as const
// eslint-disable-next-line @typescript-eslint/no-redeclare
export type InstantCardVersion =
  (typeof InstantCardVersion)[keyof typeof InstantCardVersion]

export type InstantCardObject = {
  id: string
  device: string
  device_name: string
  created_at: string
  supervisor: string
  status: InstantCardStatus
  pan: string
  type: InstantCardType
  reissue: boolean
}

export type GetInstantCardsListResponse = PaginationResponse<InstantCardObject>

export interface GetInstantCardsParams extends PaginationParams {
  card_version?: InstantCardVersion
  status?: string
  start_date?: string
  end_date?: string
  supervisor?: string
  device?: string
  reissue?: boolean
  type?: InstantCardType
}
